import { createStore } from './create-store';

type TState = {
  selectedInvoices: Set<number>;
};

type TActions = {
  toggleInvoice: (invoiceId: number) => void;
  deleteAll: () => void;
};

export const useSelectInvoicesStore = createStore<TState & TActions>(
  (set) => ({
    selectedInvoices: new Set(),

    toggleInvoice: (invoiceId: number) => {
      set((state) => {
        const newSelected = new Set(state.selectedInvoices);

        if (newSelected.has(invoiceId)) {
          newSelected.delete(invoiceId);
        } else {
          newSelected.add(invoiceId);
        }

        return { ...state, selectedInvoices: newSelected };
      });
    },

    deleteAll: () => {
      set((state) => ({ ...state, selectedInvoices: new Set() }));
    },
  }),
  'select-invoices-store',
);
